import Dropkick from 'dropkickjs';
import DataTable from 'datatables.net-dt';

(function () {
	'use strict';
	setTimeout(() => {
		// Contact Form 7 - Custom Select
		document.querySelectorAll('.wpcf7-select').forEach(function (select) {
			new Dropkick(select, {});
		});
	}, 500);

	// Slick Slider adjustment for the logos style
	document
		.querySelectorAll('.wp-block-gb-for-slick-slider-slick-slider.is-style-logos')
		.forEach(function (slider) {
			const sliderInstance = jQuery(slider);
			sliderInstance.slick('slickSetOption', 'variableWidth', true, true);
			// sliderInstance.slick('slickSetOption', 'cssEase', 'linear', true);
		});
	document
		.querySelectorAll('.wp-block-group.is-style-usp .wp-block-button.is-style-no-text')
		.forEach(function (btn) {
			var link = btn.querySelector('.wp-block-button__link');
			var href = link ? link.getAttribute('href') : null;
			if (!href) return;

			var parent = btn.closest('.wp-block-group.is-style-usp');
			if (!parent) return;

			parent.setAttribute('data-href', href);
			parent.style.cursor = 'pointer';

			var target = link.getAttribute('target');
			if (target) {
				parent.setAttribute('data-target', target);
			}
			var handlerKey = '__uspClickHandler';
			if (parent[handlerKey]) {
				parent.removeEventListener('click', parent[handlerKey]);
			}

			var handler = function (evt) {
				if (!evt.target.closest('.wp-block-button')) {
					if (target === '_blank') {
						window.open(href, '_blank');
					} else {
						window.location.href = href;
					}
				}
			};

			parent.addEventListener('click', handler);
			parent[handlerKey] = handler;
		});

	document
		.querySelectorAll('.wp-block-group.is-style-item-card .wp-block-button.is-style-no-text')
		.forEach(function (btn) {
			var link = btn.querySelector('.wp-block-button__link');
			var href = link ? link.getAttribute('href') : null;
			if (!href) return;

			var parent = btn.closest('.wp-block-group.is-style-item-card');
			var img = parent ? parent.querySelector('.wp-block-cover') : null;
			if (!parent) return;

			img.setAttribute('data-href', href);
			img.style.cursor = 'pointer';

			var target = link.getAttribute('target');
			if (target) {
				img.setAttribute('data-target', target);
			}
			var handlerKey = '__itemCardClickHandler';
			if (img[handlerKey]) {
				img.removeEventListener('click', img[handlerKey]);
			}

			var handler = function (evt) {
				if (!evt.target.closest('.wp-block-button')) {
					if (target === '_blank') {
						window.open(href, '_blank');
					} else {
						window.location.href = href;
					}
				}
			};

			img.addEventListener('click', handler);
			img[handlerKey] = handler;
		});

	// Video caption functionality - dead simple version
	document.querySelectorAll('.wp-block-video').forEach(function (videoBlock) {
		var video = videoBlock.querySelector('video');
		if (!video) return;

		videoBlock.addEventListener('click', function () {
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
		});
	});

	// Separate loop for video state listeners to avoid conflicts
	document.querySelectorAll('.wp-block-video video').forEach(function (video) {
		var caption = video.parentNode.querySelector('figcaption');
		if (!caption) return;

		video.addEventListener('play', function () {
			caption.classList.add('hidden');
		});

		video.addEventListener('pause', function () {
			caption.classList.remove('hidden');
		});
	});

	// Click handler for submenus on mobile
	document.querySelectorAll('.wp-block-navigation__responsive-container').forEach(function (nav) {
		nav.querySelectorAll('.wp-block-navigation-item').forEach(function (item) {
			var submenu = item.querySelector('.wp-block-navigation-submenu');
			if (submenu) {
				// remove the a href link for .wp-block-navigation-item__content within the submenu
				// var contentLink = submenu.querySelector('a.wp-block-navigation-item__content');
				// if (contentLink) {
				// 	contentLink.removeAttribute('href');
				// }
				item.addEventListener('click', function (e) {
					if (nav.classList.contains('has-modal-open')) {
						// e.preventDefault();
						item.classList.toggle('is-open');
					}
				});
			}
		});
	});

	// Add a modal overlay that is triggered when clicking on an element with [href="#search"]
	document.querySelectorAll('[href="#search"]').forEach(function (link) {
		link.addEventListener('click', function (e) {
			e.preventDefault();
			const searchModal = document.getElementById('search-modal');
			const isActive = searchModal.classList.contains('active');
			if (isActive) {
				searchModal.classList.remove('active');
				document.body.classList.remove('no-scroll');
				link.classList.remove('open');
			} else {
				searchModal.classList.add('active');
				document.body.classList.add('no-scroll');
				link.classList.add('open');
			}
		});
	});

	// Slick arrow button press effect for touch devices
	document.querySelectorAll('.slick-arrow').forEach(function (arrow) {
		arrow.addEventListener('click', function () {
			if (arrow.classList.contains('slick-disabled')) return;
			arrow.classList.add('pressed');
			setTimeout(() => {
				arrow.classList.remove('pressed');
			}, 700);
		});
	});

	// IFU: Datatables
	var dataTableSettings = {
		bPaginate: false,
		bLengthChange: false,
		bFilter: false,
		bInfo: false,
		pageLength: 20,
		columnDefs: [
			//{ "visible": false, "targets": [0,1,2] } // Hide columns
		],
	};
	if (document.body.classList.contains('ifu-template-default')) {
		new DataTable('#IFU_content', dataTableSettings);
		new DataTable('#IFU_archive', dataTableSettings);
	}
	if (document.body.classList.contains('coa-template-default')) {
		new DataTable('#COA_content', dataTableSettings);
		new DataTable('#COA_archive', dataTableSettings);
	}

	// Temp: add 'has-modal-open is-menu-open' to wp-block-navigation__responsive-container on init
	// document.querySelectorAll('.wp-block-navigation__responsive-container').forEach(function (nav) {
	// 	setTimeout(() => {
	// 		nav.classList.add('has-modal-open', 'is-menu-open');
	// 	}, 500);
	// });
})();
